import { Modal, Button } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Config from '../../config/Config';
import '../../css/DppModal.css'; // Import the custom CSS for DppModal

const DppModal = ({ show, handleClose, title, children, footerButtons, size, centered }) => {
  const { mainColor, secondaryColor } = Config.appearance;

  return (
    <Modal
      show={show}
      onHide={handleClose}
      animation={false}
      size={size}
      centered={centered}
      className="dpp-modal"
      style={{ '--dpp-main-color': mainColor, '--dpp-secondary-color': secondaryColor }}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {children}
      </Modal.Body>
      <Modal.Footer>
        {footerButtons || (
          <Button variant="secondary" onClick={handleClose}>
            <FormattedMessage id='close'></FormattedMessage>
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default DppModal;
